import React from 'react';

class LoadingProgressBar extends React.Component {
  render() {
    return (
      <div>
        <div className="progress mt-5" style={{ "height": 25 }}>
          <div className="progress-bar bg-primary progress-bar-striped progress-bar-animated" role="progressbar" style={{ "width": Math.round(this.props.downloadProgress / 3.0) + "%" }} aria-valuenow={this.props.downloadProgress / 3.0} aria-valuemin="0" aria-valuemax="100"></div>
          <div className="progress-bar bg-secondary progress-bar-striped progress-bar-animated" role="progressbar" style={{ "width": Math.round(this.props.downloadProgress / 3.0) + "%" }} aria-valuenow={this.props.downloadProgress / 3.0} aria-valuemin="0" aria-valuemax="100"></div>
          <div className="progress-bar bg-info progress-bar-striped progress-bar-animated" role="progressbar" style={{ "width": Math.round(this.props.downloadProgress / 3.0) + "%" }} aria-valuenow={this.props.downloadProgress / 3.0} aria-valuemin="0" aria-valuemax="100"></div>
        </div>
        <div className="text-center">
          <h2>{this.props.loadingText}</h2>
          <h1>{Math.round(this.props.downloadProgress) > 100 ? 100 : Math.round(this.props.downloadProgress)}%</h1>
        </div>
      </div>
    );
  }
}

export default LoadingProgressBar;